import { Client } from 'src/admin/users/types';
import { Family } from './hooks/useFamily';

export function formatFamilyMembers(family: Family, clientMap: Record<string, Client>): string {
  const primary = clientMap[family.mainFamilyMember.clientId];
  if (!primary) return `${family.secondaryFamilyMembers.length + 1} members`;

  const primaryFullName = `${primary.firstName} ${primary.lastName}`;
  const secondaries = family.secondaryFamilyMembers;

  if (secondaries.length === 0) return primaryFullName;

  const firstSecondary = clientMap[secondaries[0].clientId] as Client | undefined;

  let shownText: string;
  let othersCount: number;

  if (firstSecondary && firstSecondary.lastName === primary.lastName) {
    shownText = `${primary.firstName} & ${firstSecondary.firstName} ${primary.lastName}`;
    othersCount = secondaries.length - 1;
  } else {
    shownText = primaryFullName;
    othersCount = secondaries.length;
  }

  if (othersCount === 0) return shownText;
  return `${shownText}, and ${othersCount} other${othersCount === 1 ? '' : 's'}`;
}
